import React from 'react';
import { IconProps } from './ExpandIcon'; // Reusing IconProps

const CheckIcon: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
    >
      {title && <title>{title}</title>}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 13l4 4L19 7" // Simplified check icon path from Heroicons (outline check)
      />
    </svg>
  );
};

export default CheckIcon; 